import {
  getCatalog,
  type TranslationKeys,
} from "@/hooks/useTranslation/catalogs"
import { formatTranslation } from "@/hooks/useTranslation/formatTranslation"

/**
 * Minimal translate() for module-level code that runs outside the React tree
 * (Axios interceptors, service modules) and therefore cannot call
 * useTranslation(). Mirrors the language-detection logic of
 * getDefaultLanguage() in hooks/useTranslation/useTranslation.tsx — keep the
 * two in sync if that logic ever changes. That keeps it reading the UI
 * language's catalog, which index.tsx loads before the app renders.
 */
function getModuleLanguage(): "DE" | "EN" {
  const saved = localStorage.getItem("language")
  if (saved === "DE" || saved === "EN") return saved

  const browserLanguage = navigator.language.split("-")[0].toUpperCase()
  return browserLanguage === "EN" ? "EN" : "DE"
}

export function moduleTranslate(
  key: TranslationKeys,
  dynamicValues?: Record<string, string | number>,
): string {
  const lang = getModuleLanguage()
  // Mirror translate() in useTranslation.tsx: fall back to the key when the
  // catalog value is missing/empty, and resolve the ICU subset through the SAME
  // formatter — a hand-copied second resolver is what let `#` go unhandled here.
  const translation = getCatalog(lang)?.[key] || key

  return formatTranslation(translation, dynamicValues)
}
